<template>
  <b-form>
    <b-card>
      <b-card-text>
        <b-row>
          <b-col
            sm="12"
            md="6"
          ><h6 class="mb-1">
            Satıcı Güncelle
          </h6></b-col>
        </b-row>
        <b-form-group
          label="Satıcı Tipi"
        >
          <v-select
            v-model="id_supplier_type"
            label="title"
            :options="supplier_type"
          />
        </b-form-group>
        <b-form-group label="Satıcı Kodu">
          <b-form-input
            v-model="formData.scode"
            placeholder="Satıcı Kodu"
            @change="sCodeCheck"
          />
        </b-form-group>
        <b-row v-if="id_supplier_type.id === 1">
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group label="Firma Adı">
              <b-form-input
                v-model="formData.company"
                placeholder="Firma Adı"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group label="İlgili Kişi">
              <b-form-input
                v-model="formData.name"
                placeholder="İlgili Kişi"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col
            md="12"
          >
            <b-form-group label="Adı Soyadı">
              <b-form-input
                v-model="formData.name"
                placeholder="Adı Soyadı"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group label="Telefon">
              <b-input-group>
                <b-input-group-prepend is-text>
                  TR (+9)
                </b-input-group-prepend>
                <cleave
                  id="phone"
                  v-model="formData.phone"
                  class="form-control"
                  :raw="false"
                  :options="options.phone"
                  placeholder="Telefon"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col

            sm="12"
            md="6"
          >
            <b-form-group label="Faks">
              <b-form-input
                v-model="formData.fax"
                placeholder="Faks"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group label="E-Posta">
              <b-form-input
                v-model="formData.email"
                placeholder="E-Posta"
              />
            </b-form-group>
          </b-col>
          <b-col

            sm="12"
            md="6"
          >
            <b-form-group label="Web Sitesi">
              <b-form-input
                v-model="formData.website"
                placeholder="Web Sitesi"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Ek Notlar">
              <b-form-textarea
                v-model="formData.notes"
                placeholder="Ek Notlar"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-card>
      <b-card-text>
        <b-row>
          <b-col
            sm="12"
            md="6"
          ><h6 class="mb-1">
            Fatura Bilgileri
          </h6></b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group label="Vergi Dairesi">
              <b-form-input
                v-model="formData.tax_office"
                placeholder="Vergi Dairesi"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group label="Vergi No">
              <b-form-input
                v-model="formData.tax_number"
                placeholder="Vergi No"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group label="İl">
              <v-select
                v-model="id_cities"
                label="title"
                :options="cities"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
          >
            <b-form-group label="İlçe">
              <v-select
                v-model="id_districts"
                label="title"
                :options="districts"
                :disabled="id_cities.id == null"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-textarea
              v-model="formData.address"
              placeholder="Adres"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-button
      variant="danger"
      :disabled="submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </b-form>
</template>

<script>
import {
  BForm,
  BCard,
  BCardText,
  BFormInput,
  BFormTextarea,
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BInputGroupPrepend,
  BInputGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.tr'

export default {
  name: 'SuppliersEdit',
  components: {
    BForm,
    BCard,
    BCardText,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    vSelect,
    BRow,
    BCol,
    BButton,
    Cleave,
    BInputGroupPrepend,
    BInputGroup,
  },
  data() {
    return {
      detailForm: false,
      submitStatus: false,
      scodeControl: {},
      supplier_type: [
        {
          id: 1,
          title: 'Tüzel Kişi',
        },
        {
          id: 2,
          title: 'Gerçek Kişi',
        },
      ],
      id_supplier_type: {
        id: 1,
        title: 'Tüzel Kişi',
      },
      id_cities: {
        id: null,
        title: null,
      },
      id_districts: {
        id: null,
        title: null,
      },
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'TR',
        },
      },
      formData: {
        scode: null,
        name: null,
        company: null,
        phone: null,
        fax: null,
        email: null,
        website: null,
        tax_office: null,
        tax_number: null,
        address: null,
        notes: null,
        id_suppliers_type: null,
        id_cities: null,
        id_districts: null,
      },
    }
  },
  computed: {
    supplierData() {
      return this.$store.getters['suppliers/getSupplier']
    },
    cities() {
      return this.$store.getters['cities/getCities']
    },
    districts() {
      if (this.id_cities.id) {
        return this.$store.getters['districts/getDistricts']
      }
      return []
    },
    scodeStatus() {
      return this.$store.getters['suppliers/getSupplierCodeControl']
    },
    saveStatus() {
      const status = this.$store.getters['suppliers/getSupplierSaveStatus']
      return status
    },
  },
  watch: {
    id_cities(val) {
      if (val.id) {
        this.getDistricts()
      }
    },
    supplierData(val) {
      this.setFormData(val)
    },
    saveStatus(val) {
      if (val.status === true) {
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getCities()
    this.getSupplier()
  },
  methods: {
    getSupplier() {
      this.$store.dispatch('suppliers/supplierView', this.$route.params.id)
    },
    setFormData(data) {
      this.formData = data
      this.id_cities = {
        id: data.id_cities,
        title: data.cities,
      }
      this.id_districts = {
        id: data.id_districts,
        title: data.district,
      }
    },
    sCodeCheck() {
      if (this.formData.scode.length > 3) {
        this.$store.dispatch('suppliers/scodeControl', this.formData.scode)
      }
      if (this.formData.scode === '') {
        this.$store.dispatch('suppliers/scodeControl', this.formData.scode)
      }
    },
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    getCities() {
      this.$store.dispatch('cities/citiesList', {
        select: ['cities.id AS id', 'cities.title AS title'],
      })
    },
    getDistricts() {
      if (this.id_cities.id) {
        this.$store.dispatch('districts/districtsList', {
          select: ['districts.id AS id', 'districts.title AS title'],
          where: {
            id_cities: this.id_cities.id,
          },
        })
      }
    },
    submitForm() {
      this.submitStatus = true
      const submitData = this.formData
      submitData.id_suppliers_type = this.id_supplier_type.id
      submitData.id_cities = this.id_cities.id
      submitData.id_districts = this.id_districts.id
      this.$store.dispatch('suppliers/supplierSave', this.formData)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
